import React from "react";
import { DetailRow } from "./DetailRow";

const CommonDetailModal = ({
  isOpen,
  onClose,
  title,
  details = [], // Array of { label, value, colSize }
  topContent,
  bottomContent,
  detailsHeader,
  detailsContent,
  maxWidth = "800px",
  width,
  contentClassName = "modal-content",
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal" style={{ display: "block" }}>
      <div className={contentClassName} style={{ maxWidth, width }}>
        {title && (
          <div className="row">
            <div className="col-12 page_heading">
              <h4 className="text-center pt-2">{title}</h4>
              <span className="close pr-2" onClick={onClose}>
                &times;
              </span>
            </div>
          </div>
        )}

        {topContent}

        {(detailsHeader || details?.length > 0) && (
          <div className="col-md-12 mt-2 p-0">
            <div className="p-2 h-100" style={{ borderRadius: "6px", marginBottom: "15px" }}>
              {detailsHeader}
              {detailsContent || (
                <div className="row mx-0 mt-2">
                  {details.map((detail, index) => (
                    <div key={index} className={`col-md-${detail.colSize || 4}`}>
                      <DetailRow label={detail.label} value={detail.value} />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {bottomContent}
      </div>
    </div>
  );
};

export default CommonDetailModal;
